import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RecentsPage } from './recents';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    RecentsPage,
  ],
  imports: [
    IonicPageModule.forChild(RecentsPage),
    TranslateModule.forChild(),
    ComponentsModule
  ],
})
export class RecentsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/recents/recents.module.ts